import { Folder, ReceiptText, TrendingUp, WalletCards } from "lucide-react";
import { Link, Navigate } from "react-router-dom";
import { useAuth } from "@/auth/AuthContext";
import BoardWorkspace from "@/components/BoardWorkspace";

const folders = [
  ["Invoices", "Invoice review, approval, sent status, and payment updates", "/invoices", ReceiptText, "billing"],
  ["Production Tracker", "Weekly paid invoice tracking", "/production", TrendingUp, "production_tracker"],
  ["Payroll", "In-House and Contractor profiles with payment history", "/payroll", WalletCards, "payroll"],
];

export default function BillingPage() {
  const { canAccessBilling, canManagePayroll, isFeatureEnabled } = useAuth();
  if (!canAccessBilling || !isFeatureEnabled("billing")) {
    return <Navigate replace to="/master-project-board" />;
  }
  const available = folders.filter(([, , , , feature]) => isFeatureEnabled(feature) && (feature !== "payroll" || canManagePayroll));
  return <BoardWorkspace eyebrow="Restricted financial workspace" headingTestId="billing-heading" subtitle="Choose a billing folder to work in. Billing is available only to Company Owner/Admin and Office/Admin." title="Billing"><section className="billing-folders" data-testid="billing-folders">{available.map(([title, description, to, Icon]) => <Link className="billing-folder" data-testid={`billing-folder-${title.toLowerCase().replaceAll(" ", "-")}`} key={to} to={to}><Folder className="billing-folder-tab" size={38} /><Icon size={30} /><strong>{title}</strong><p>{description}</p></Link>)}</section></BoardWorkspace>;
}
